import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import GenericSelect from '../reutilizables/genericSelect/GenericSelect'
import * as listaVentaService from '../servicios/listaVentaService'
import Error from '../ui/Error'
import InputEditable from '../ui/InputEditable'

const lengthCaracteresListaVenta = 3

const ListaDeVentas = ({
  onChangeState,
  idVendedor,
  vieneDeAdministrar,
  actualizarPantallaDetalle,
  value
}) => {
  const [listas, setListas] = useState([])
  const [listaNueva, setListaNueva] = useState('')
  const [showInput, setShowInput] = useState(true)
  const [errores, setErrores] = useState({})

  useEffect(() => {
    const obtenerListas = async () => {
      const listasRtn = await listaVentaService.buscarListaPorVendedor(idVendedor)
      setListas(
        listasRtn.data.map((element) => ({
          value: element.idListaVenta,
          label: element.nombre
        }))
      )
    }
    obtenerListas()
  }, [idVendedor, actualizarPantallaDetalle])

  const guardarLista = async () => {
    try {
      const lista = {
        idVendedor: idVendedor,
        nombre: listaNueva,
        idListaVentaEstado: 2
      }

      if (listas.map((lista) => lista.nombre).includes(listaNueva)) {
        setErrores({
          ...errores,
          errores: 'El nombre de su lista ya existe'
        })
      } else {
        if (listaNueva.length > lengthCaracteresListaVenta) {
          setErrores({})
          setShowInput(!showInput)
          const nuevaLista = await listaVentaService.insertarLista(lista)
          onChangeState('idListaVenta', nuevaLista.data.idListaVenta)
          refrescasListas()
        } else {
          setErrores({
            ...errores,
            errores: 'El nombre de tu lista debe contener más de tres caracteres'
          })
        }
      }
    } catch (error) {
      const mensaje = `Ocurrió un error al guardar la lista.`
      toastErrorLog(error, mensaje, 'listaVenta')
    }
  }

  const handleInputChange = (e) => {
    setListaNueva(e.target.value)
  }

  const refrescasListas = async () => {
    const listasRtn = await listaVentaService.buscarListaPorVendedor(idVendedor)
    setListas(
      listasRtn.data.map((lista) => {
        return { value: lista.idListaVenta, label: lista.nombre }
      })
    )
  }

  return (
    <>
      {!vieneDeAdministrar && (
        <p className="descripcion-cuadro-publicacion">
          Indica si el artículo pertenece a una Lista de Ventas.
        </p>
      )}
      <div className="row" id="">
        <div className="col-12 col-md-6 ">
          <GenericSelect
            options={listas}
            value={value || ''}
            label="Elegir Lista:"
            id="idListaVenta"
            onChange={(nuevoValor) => onChangeState('idListaVenta', nuevoValor)}
            className="select-publicacion-chico border-warning w-100 ml-2"
          />
        </div>
        <div className="crear-lista-venta">
          <div
            className="col"
            id="crear-lista-venta"
            onClick={() => {
              setShowInput(!showInput)
            }}
          >
            Crear una nueva Lista
            <i className="fa fa-plus f-ebm-green ml-3" aria-hidden="true" />
          </div>
          {!showInput ? (
            <li id="li-crear-lista">
              <Error name="errores" errores={errores}>
                <InputEditable
                  type="text"
                  name="nombre"
                  placeholder="Ingresa el nombre de tu Lista"
                  onChange={handleInputChange}
                  texto={listaNueva}
                  classInput="input-lista-venta"
                  classLabel="publicacion-precio"
                  onClickOutSide={guardarLista}
                  value={listaNueva}
                />
              </Error>
            </li>
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  )
}

ListaDeVentas.propTypes = {
  onChangeState: PropTypes.func.isRequired,
  idVendedor: PropTypes.number.isRequired,
  vieneDeAdministrar: PropTypes.bool,
  actualizarPantallaDetalle: PropTypes.bool,
  value: PropTypes.number.isRequired
}

export default ListaDeVentas
